<template>
  <b-card
    :img-src="item.imgSrc"
    img-alt="Image"
    img-top
    tag="article"
    class="m-b-100 card-size"
    body-class="card-body"
  >
    <b-card-title
      class="title text-primary font-weight-bold card-ctx f-s-30 m-b-36 l-h-20 blue"
    >
      {{ item.title }}
    </b-card-title>
    <b-card-text class="text-primary l-h-35 grey-dark m-b-26">
      {{ item.text }}
    </b-card-text>
    <div class="d-flex justify-content-end">
      <router-link
        class="card-ctx text-primary font-weight-bold l-h-20"
        :to="{name: item.routeName}"
      >
        {{ item.linkLabel }}
      </router-link>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'ServiceCardItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-size {
  width: 462px;
  height: 617px;
}

.card-body {
  padding: 43px 29px;
}

@media only screen and (max-width: 575px) {
  .card-size {
    margin: 0 auto 100px;
    width: auto !important;
    text-align: center;
  }
  .title {
    line-height: 35px;
  }
}
</style>
